import React from 'react';
import {
  Button,
  Label,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@cargomatic/ui';
import { Trash } from 'lucide-react';
import FormGrid from './FormGrid';

const orderTypes = [
  {
    name: 'Domestic',
    value: 'domestic',
  },
  {
    name: 'Import',
    value: 'import',
  },
  {
    name: 'Export',
    value: 'export',
  },
  {
    name: 'Reposition',
    value: 'reposition',
  },
];

export default function OrderTypeRateConditionField({
  condition,
  onChange,
  onRemove,
}) {
  const { criteria: value } = condition;

  function handleRemove() {
    onRemove(condition);
  }

  function handleChange(criteria) {
    onChange({ ...condition, criteria });
  }

  return (
    <FormGrid>
      <Label className="w-48">Order Type</Label>
      <Select className="flex-1" value={value} onValueChange={handleChange}>
        <SelectTrigger className="">
          <SelectValue placeholder="Order Type" />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectLabel>Order Type</SelectLabel>
            {orderTypes.map((orderType) => (
              <SelectItem value={orderType.value} key={orderType.value}>
                {orderType.name}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
      <div>
        <Button variant="icon" onClick={handleRemove}>
          <Trash className="w-3.5 h-3.5" />
        </Button>
      </div>
    </FormGrid>
  );
}
